import React, { useCallback, useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import CustomBottomSheet from '../Reusables/bottomSheet/CustomBottomSheet';
import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { s, fs, iconSize, v } from '../../utils/libs';
import { GTFonts, theme } from '../../theme';

interface LocationBottomSheetProps {
  bottomSheetRef: React.RefObject<BottomSheetModal | null>;
  children?: React.ReactNode;
  title?: string;
  onClose?: () => void;
  footer?: React.ReactNode;
}

const LocationBottomSheet: React.FC<LocationBottomSheetProps> = ({
  bottomSheetRef,
  children,
  title = 'Select Business',
  onClose,
  footer,
}) => {
  const snapPoints = useMemo(() => ['70%'], []);

  const handleSheetChanges = useCallback(
    (index: number) => {
      if (index === -1 && onClose) onClose();
    },
    [onClose],
  );

  const header = (
    <View style={styles.header}>
      {/* <View/> */}
      <Text style={styles.title}>{title}</Text>
      {/* <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
        <FontAwesome6
          name="xmark"
          size={iconSize(18)}
          color={theme.colors.text}
        />
      </TouchableOpacity> */}
    </View>
  );

  return (
    <CustomBottomSheet
      bottomSheetModalRef={bottomSheetRef as any}
      snapPoints={snapPoints}
      enableDynamicSizing={false}
      handleSheetChanges={handleSheetChanges}
      header={header}
      footer={footer}>
      <View style={styles.content}>{children}</View>
    </CustomBottomSheet>
  );
};

export default LocationBottomSheet;

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: s(12),
    paddingVertical: s(8),
  },
  title: {
    fontSize: fs(20),
    marginBottom: v(16),
    lineHeight: fs(28),
    fontFamily: GTFonts.semibold,
    color: theme.colors.text,
  },
  closeBtn: {
    padding: s(6),
  },
  content: {
    paddingHorizontal: s(12),
    // paddingBottom: v(10, 'height'),
  },
});
